import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePermissions } from "@/hooks/usePermissions";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

export default function Suppliers() {
  const { can, loaded } = usePermissions();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!loaded || !can("supplier.list")) { setRows([]); return; }
    (async () => {
      try { const { data } = await api.get("/suppliers"); setRows(data); }
      catch { setRows([]); }
    })();
  }, [loaded, can]);
  const filtered = rows.filter((r) => !q || r.company_name.toLowerCase().includes(q.toLowerCase()) || (r.categories || []).join(" ").toLowerCase().includes(q.toLowerCase()));

  if (loaded && !can("supplier.list")) {
    return (
      <div className="space-y-4" data-testid="suppliers-denied">
        <div>
          <div className="eyebrow">Supplier database</div>
          <h1 className="font-display text-3xl font-extrabold text-[#0A2540] tracking-tight mt-1">Approved suppliers</h1>
        </div>
        <Card className="p-6 border-slate-200 text-sm text-slate-600">
          You don't have permission to view the supplier directory. Backend is authoritative — any direct request would return 403.
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">Supplier database</div>
        <h1 className="font-display text-3xl font-extrabold text-[#0A2540] tracking-tight mt-1">Approved suppliers</h1>
      </div>
      <Input placeholder="Search suppliers or categories…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md" data-testid="supplier-search-input" />
      <Card className="border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-6 py-3">Company</th>
              <th className="px-6 py-3">Contact</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">Categories</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {filtered.map((s) => (
              <tr key={s.id} data-testid={`supplier-row-${s.id}`}>
                <td className="px-6 py-4 font-medium text-[#0A2540]">{s.company_name}</td>
                <td className="px-6 py-4">{s.name}</td>
                <td className="px-6 py-4 text-slate-600">{s.email}</td>
                <td className="px-6 py-4">
                  <div className="flex flex-wrap gap-1">
                    {(s.categories || []).map((c) => (
                      <span key={c} className="text-xs px-2 py-0.5 bg-slate-100 text-slate-700 rounded">{c}</span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
